import { useState, useEffect } from 'react';
import { Route, Routes } from 'react-router-dom';
import { useNavigate } from "react-router-dom";

import { Promotions } from './components/pages/promotions/Promotions';
import { Sets } from './components/pages/sets/Sets';
import { Rolls } from './components/pages/rolls/Rolls';
import { Premium } from './components/pages/premium/Premium';
import { Combo } from './components/pages/combo/Combo';
import { Pizza } from './components/pages/pizza/Pizza';
import { Pizza_toppings } from './components/pages/pizza_toppings/Pizza_toppings';
import { Salads } from './components/pages/salads/Salads';
import { Gunkan_nigiri } from './components/pages/gunkan_nigiri/Gunkan_nigiri';
import { Drinks } from './components/pages/drinks/Drinks';
import { Home } from './components/home/Home';
import { Header } from './components/header/Header';

import { Navbar } from './components/navbar/Navbar';


import { Login } from './components/login/Login';
import { Cabinet } from './components/cabinet/Cabinet';
import { CartList } from './components/cartList/CartList'



import styles from './App.module.css';



//ИСПРАВИТЬ КОСЯКИ ПО САЙТУ:
// - App.jsx - setNewProducts(value) сетает состояние только со второго круга, поэтому для пуша новых товаров 
// newProducts в массив продуктов products пришлось мутировать products.push(newProducts[i]), нужно это исправить на 
// updatedProducts.push(newProducts[i]), а затем setProducts(updatedProducts)

// - В Upload из AddProduct отправить пустое состояние url после отправки формы с добавлением нового товара (обнулить поле url)








// Обновляем массив
// Принимает три аргумента: массив phones, элемент который нужно обновить, индекс этого элемента
const updateCartList = (cartList, newProduct, index) => {
    // Если количество одного телефона равняется 0, убрать его из корзины
    if (newProduct.count === 0) {
        return [...cartList.slice(0, index), ...cartList.slice(index + 1)];
    }

    // Если индекс элемента -1, это значит что в корзине нет этого телефона
    // И его нужно добавить
    if (index === -1) {
        return [...cartList, newProduct];
    }

    // Если этот телефон есть, то массив нужно обновить
    // Телефон, будь он обычным или обновлённым получаем из второго аргумента
    // Таким образом вычисление, и структура объекта телефона находится в updatePhone
    return [...cartList.slice(0, index), newProduct, ...cartList.slice(index + 1)];
};

// Функция, занимающаяся проверкой и структурой телефона
// Принимает три параметра, полученный телефон, телефон в корзине (если тот есть), и количество которое нужно купить
// Если телефон в корзине есть, то возвращаем все поля телефона, изменяя его totalPrice и count, которое зависит от количества купленного
// Если телефона в корзине нет, то возвращаем объект, который содержит нужные для дальнейшего поля
const updateProduct = (getProduct, productInCart, quantity) => {
    // debugger
    if (productInCart) {
        return {
            ...productInCart,
            totalPrice: Number(productInCart.totalPrice) + quantity * Number(getProduct.price),
            count: productInCart.count + quantity
        };
    }

    return {
        id: getProduct.id,
        name: getProduct.name,
        url: getProduct.url,
        totalPrice: getProduct.price,
        count: 1
    };
};

export const App = () => {

    // const navigate = useNavigate();

    const [isAuthorized, setIsAuthorized] = useState(false);
    const [products, setProducts] = useState([]);
    const [newProducts, setNewProducts] = useState([]);
    const [cartList, setCartList] = useState([]);


    useEffect(() => {
        let email = localStorage.getItem('email')
        if (email === 'admin@gmail.com') {
            setIsAuthorized(true)
        }
    }, [])

    let fetchProducts =  (value) => {
         setNewProducts(value)
    }
    

//ADD NEW PRODUCTS TO ALL PRODUCTS
let resetProducts = () => {   // async await
    let productsNames = [];
    // let updatedProducts = [];
    

    for (let j = 0; j < products.length; j++) {
        productsNames.push(products[j].name)
    }

    for (let i = 0; i < newProducts.length; i++) {
        if (!productsNames.includes(newProducts[i].name)) {
            products.push(newProducts[i])
        }
    }

//  setProducts(updatedProducts)  
}

useEffect(() => {
    resetProducts()
}, [newProducts])



    const addProductInCart = (id) => {
        
        setCartList(() => {
            const getProduct = products.find((product) => product.name === id);
            const getProductIndex = cartList.findIndex((product) => product.name === id);
            const productInCart = cartList[getProductIndex];

            const newProduct = updateProduct(getProduct, productInCart, 1);
            const newArray = updateCartList(cartList, newProduct, getProductIndex);

            return newArray
        });
    };


    const removeProductFromCart = (id) => {

        setCartList(() => {
            const getProduct = products.find((product) => product.name === id);
            const getProductIndex = cartList.findIndex((product) => product.name === id);
            const productInCart = cartList[getProductIndex];

            const newProduct = updateProduct(getProduct, productInCart, -1);
            const newArray = updateCartList(cartList, newProduct, getProductIndex);

            return newArray
        });
    };


    const deletePurchasedProduct = (id) => {

        setCartList(() => {
            const getProduct = products.find((product) => product.name === id);
            const getProductIndex = cartList.findIndex((product) => product.name === id);
            const productInCart = cartList[getProductIndex];

            const newProduct = updateProduct(getProduct, productInCart, -productInCart.count);
            const newArray = updateCartList(cartList, newProduct, getProductIndex);

            return newArray
        });
    };


    // callbacks
    let updateData = (value) => {
        setIsAuthorized(value)
    }

    // const clearCartlist = (value) => {
    //     setCartList(value)
    // }

    return (
        <div className={styles.app}>
            <Header cartList={cartList}
                    isAuthorized={isAuthorized} />

            <Navbar />

            <div className={styles.content}>

                <Routes>
                <Route path='/'
                        element={<Home />}
                    />
                    <Route path='/promotions'
                        element={<Promotions isAuthorized={isAuthorized}
                            fetchProducts={fetchProducts}
                            addProductInCart={addProductInCart}
                            deletePurchasedProduct={deletePurchasedProduct}
                            cartList={cartList} />}
                    />
                    <Route path='/sets'
                        element={<Sets isAuthorized={isAuthorized}
                            fetchProducts={fetchProducts}
                            addProductInCart={addProductInCart}
                            deletePurchasedProduct={deletePurchasedProduct}
                            cartList={cartList} />}
                    />
                    <Route path='/rolls'
                        element={<Rolls isAuthorized={isAuthorized}
                            fetchProducts={fetchProducts}
                            addProductInCart={addProductInCart}
                            deletePurchasedProduct={deletePurchasedProduct}
                            cartList={cartList} />}
                    />
                    <Route path='/premium'
                        element={<Premium isAuthorized={isAuthorized}
                            fetchProducts={fetchProducts}
                            addProductInCart={addProductInCart}
                            deletePurchasedProduct={deletePurchasedProduct}
                            cartList={cartList} />}
                    />
                    <Route path='/combo'
                        element={<Combo isAuthorized={isAuthorized}
                            fetchProducts={fetchProducts}
                            addProductInCart={addProductInCart}
                            deletePurchasedProduct={deletePurchasedProduct}
                            cartList={cartList} />}
                    />
                    <Route path='/pizza'
                        element={<Pizza isAuthorized={isAuthorized}
                            fetchProducts={fetchProducts}
                            addProductInCart={addProductInCart}
                            deletePurchasedProduct={deletePurchasedProduct}
                            cartList={cartList} />}
                    />
                    <Route path='/pizza_toppings'
                        element={<Pizza_toppings isAuthorized={isAuthorized}
                            fetchProducts={fetchProducts}
                            addProductInCart={addProductInCart}
                            deletePurchasedProduct={deletePurchasedProduct}
                            cartList={cartList} />}
                    />
                    <Route path='/salads'
                        element={<Salads isAuthorized={isAuthorized}
                            fetchProducts={fetchProducts}
                            addProductInCart={addProductInCart}
                            deletePurchasedProduct={deletePurchasedProduct}
                            cartList={cartList} />}
                    />
                    <Route path='/gunkan_nigiri'
                        element={<Gunkan_nigiri isAuthorized={isAuthorized}
                            fetchProducts={fetchProducts}
                            addProductInCart={addProductInCart}
                            deletePurchasedProduct={deletePurchasedProduct}
                            cartList={cartList} />}
                    />
                    <Route path='/drinks'
                        element={<Drinks isAuthorized={isAuthorized}
                            fetchProducts={fetchProducts}
                            addProductInCart={addProductInCart}
                            deletePurchasedProduct={deletePurchasedProduct}
                            cartList={cartList} />}
                    />
                    <Route path='/login'
                        element={<Login updateData={updateData} />}
                    />
                    <Route path='/cabinet'
                        element={<Cabinet 
                            isAuthorized={isAuthorized}/>}
                    />
                    <Route path='/cartList'
                        element={<CartList
                            cartList={cartList}
                            addProductInCart={addProductInCart}
                            removeProductFromCart={removeProductFromCart}
                            deletePurchasedProduct={deletePurchasedProduct} />}
                    />
                </Routes>

            </div>
        </div>

    )
};